import withObservables from "@nozbe/with-observables";
import { MenuItem } from "@mui/material";
import { AvatarRingIcon, DeleteNewIcon, TickIcon } from "../../../assets/icons/icon";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const ListItem = ({
  customerCount,
  handleAction,
  business,
  index,
  I18n,
  item,
  user,
}) => {

  const isSelected = business?.id === item?.id;

  const avatarContent = item?.image_url ? (
    <img
      src={item.image_url}
      alt={item?.name || ""}
      className={styles.listItemAvatar}
    />
  ) : (
    <span className={styles.listPlaceholder}>
      {item?.name
        ? item.name.trim().charAt(0).toUpperCase()
        : user?.phone_number
          ? user.phone_number.charAt(0).toUpperCase()
          : ""}
    </span>
  );

  return (
    <MenuItem
      onClick={() => {
        triggerLogEvent(analytics, "setting_business_switch", { business_id: item?.id });
        handleAction("switch", item);
      }}
      key={index}
      id={`business_list_${index}`}
    >
      <div className={styles.dropDownListMain}>
        <div className={styles.dropDownListIcon}>
          {isSelected ? (
            <div className={styles.listAvatarSelected}>{avatarContent}</div>
          ) : (
            <div className={styles.listAvatarWithRing}>
              <span className={styles.listAvatarRing} aria-hidden>
                <AvatarRingIcon className={styles.listAvatarRingSvg} />
              </span>
              <div className={styles.listAvatarInner}>{avatarContent}</div>
            </div>
          )}
        </div>
        <div className={styles.dropDownListText}>
          <span className={styles.businessName}>
            {user
              ? item?.name
                ? item.name.length > 22
                  ? item.name.substring(0, 22) + "..."
                  : item.name
                : user.phone_number
              : null}
          </span>
        </div>
          {business?.id === item?.id && (
            <span className={styles.checkIconDropdownList}>
            <TickIcon />
            </span>
          )}
      </div>
    </MenuItem>
  );
};

const enhance = withObservables(["item"], ({ item }) => ({
  customerCount: item.customer.observeCount(),
}));

export default enhance(ListItem);
